import type { CSSProperties, FC } from 'react'

type Props = {
  size?: number
  style?: CSSProperties
  className?: string
}

const IconArrowRightMini: FC<Props> = ({ size = 16, style, className }) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      style={style}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6953 9.10938L6.38867 13.4453C6.30078 13.5332 6.21289 13.5625 6.125 13.5625C6.03711 13.5625 5.94922 13.5332 5.89062 13.4746L5.30469 12.8887C5.24609 12.8301 5.2168 12.7422 5.2168 12.625C5.2168 12.5371 5.24609 12.4492 5.30469 12.3906L8.79102 8.875L5.30469 5.35938C5.24609 5.30078 5.2168 5.24219 5.2168 5.125C5.2168 5.03711 5.24609 4.94922 5.30469 4.86133L5.89062 4.27539C5.94922 4.2168 6.03711 4.1875 6.125 4.1875C6.21289 4.1875 6.30078 4.2168 6.38867 4.27539L10.6953 8.61133C10.7539 8.69922 10.7832 8.78711 10.7832 8.875C10.7832 8.99219 10.7539 9.08008 10.6953 9.13867V9.10938Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconArrowRightMini
